// ...imports

import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProfilePicture from "../../../../SharedComponents/ProfilePicture";
import { SetSelectedPageWithoutUrl } from "../../../../AppMenu/Store";
import { ParseDate } from "../../../../../Helpers/DateHelper";

const NotificationListRow = ({ notification }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const HandleGoToResult = () => {
    switch (notification.applicationType) {
      case 1:
        navigate("/iwrapup/" + notification.applicationResultId, {
          state: { candidateId: notification.candidateId, backUrl: "/dash" },
        });
        break;
      case 0:
        navigate("/twrapup/" + notification.applicationResultId, {
          state: { candidateId: notification.candidateId, backUrl: "/dash" },
        });
        break;
      case 2:
        break;
      default:
        console.log("something wrong with HandleGoToResult at NotificationModal");
    }
  };

  const HandleGoToCandidate = () => {
    navigate("/candidate", { state: { candidateId: notification.candidateId, backUrl: "/dash" } });
    dispatch(SetSelectedPageWithoutUrl({ url: "/createCandidate/" }));
  };

  return (
    <div className={"p-0 mb-3 hover-bg-darken"}>
      <Row className={"text-20 text-color-gray-dark fw-medium justify-content-between"} style={{ height: "50px" }}>
        <Col xs={6} lg={4} className={"align-content-center"}>
          <Row className={"mx-0 h-100 justify-content-sm-center"}>
            <Col xs={"auto"} className={"align-content-center d-none d-sm-block"}>
              <Row className={"justify-content-end"}>
                <Col xs={"auto"}>
                  <ProfilePicture
                    userId={notification.applicationUserId}
                    profilePicFileName={notification.profilePic}
                    size={40}
                  />
                </Col>
              </Row>
            </Col>
            <Col className={"align-content-center"}>
              <div className="hover-container h-100 w-100 p-0 position-relative">
                <div className="position-absolute top-0 h-100 w-100 hover-actions-reversed">
                  <Row className={"h-100 justify-content-center justify-content-sm-start"}>
                    <Col xs={"auto"} className={"align-content-center"}>
                      {notification?.candidateName}
                    </Col>
                  </Row>
                </div>

                <div className="position-absolute top-0 h-100 w-100 hover-actions">
                  <Row className={"h-100 justify-content-center justify-content-sm-start"}>
                    <Col xs={"auto"} className={"align-content-center"}>
                      <Button
                        size="sm"
                        className="button secondary"
                        style={{ borderRadius: "10px" }}
                        onClick={HandleGoToCandidate}
                      >
                        {t("goToCandidateButtonLabel")}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Col>

        <Col xs={6} lg={4} className="align-content-center text-16">
          <div className="hover-container h-100 w-100 p-0 position-relative">
            <div className="position-absolute top-0 h-100 w-100 hover-actions-reversed">
              <Row className={"justify-content-center h-100"}>
                <Col xs={"auto"} className={"align-content-center text-center"}>
                  {notification?.applicationName} {t("notificationCompletedLabel")}
                </Col>
              </Row>
            </div>

            <div className="position-absolute top-0 h-100 w-100 hover-actions">
              <Row className={"justify-content-center h-100"}>
                <Col xs={"auto"} className={"align-content-center"}>
                  <Button
                    size="sm"
                    className="button secondary"
                    style={{ borderRadius: "10px" }}
                    onClick={HandleGoToResult}
                  >
                    {t("goToResultButtonLabel")}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>

        <Col xs={4} className={"align-content-center d-none d-lg-block"}>
          <Row className={"me-5 text-18 text-color-gray-light fw-medium justify-content-end"}>
            <Col xs={"auto"} className={"pe-0"}>
              {ParseDate(notification?.finishDate).date} {ParseDate(notification?.finishDate).time}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default NotificationListRow;
